import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent";


class ExtendedWarrantyComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element
        this.modal = new GenericModalComponent(this.element.querySelector('.generic-modal'));
        this.submit = this.element.querySelector('.submit-warranty');
        this.inputFile = this.element.querySelectorAll('input[type="file"]');
        this.receiptInput = this.element.querySelector('input[name="filenameReceipt"]');
        this.speedometerInput = this.element.querySelector('input[name="filenameSpeedometer"]');

        this.local = this.element.querySelector('#currentLocal').value;
        this.country = this.element.querySelector('#currentCountry').value;
        this.siteId = this.element.querySelector('#siteId').value;
        this.endpoint = `/api/1.0/trelleborg/premium/warranty5000/create?siteId=${this.siteId}&locale=${this.local}&country=${this.country}`

        this.machineBrandEndopoint = `/api/1.0/trelleborg/premium/fleet/brand/${this.local}`;
        this.rearTireSizeEndpoint = `/api/1.0/trelleborg/premium/warranty5000/tireModelTypeSize5000/`


        this.init();
    }


    populateBrandDropdown() {
        const select = document.getElementById('machineBrand');
        if (!select || !this.machineBrands) return;

        this.machineBrands.forEach(brand => {
            const option = document.createElement('option');
            option.value = brand.value;
            option.textContent = brand.label;
            select.appendChild(option);
        });
    }

    getMachineBrands() {
        return youserxp.ajax(this.machineBrandEndopoint, {
            method: 'GET',
            auth: true
        }).then(
            (data) => {
                this.machineBrands = data.body;
                this.populateBrandDropdown();
            },
            (err) => console.log(err)
        );
    }


    populateRearTiresSizeByModelDropdown() {
        this.modelSelect = this.element.querySelector('#rearTireModel');
        const sizeSelect = this.element.querySelector('#rearTiresSize');

        this.modelSelect.addEventListener('change', (e) => {
            let modelId = e.target.value;

            sizeSelect.innerHTML = '<option value="" disabled selected>Select rear tire size</option>';

            return youserxp.ajax(`/api/1.0/trelleborg/premium/warranty5000/tireModelTypeSize5000/${modelId}`, {
                method: 'GET',
                auth: true
            }).then(
                (data) => {
                    this.tireSize = data.body;
                    this.tireSize.forEach(size => {
                        const option = document.createElement('option');
                        option.value = size
                        option.textContent = size
                        sizeSelect.appendChild(option);
                    })
                },
                (err) => console.log(err)
            )
        })
    }


    checkValidationForm() {
        event.preventDefault();

        let isValid = true;

        this.inputs = this.element.querySelectorAll('input[required][type="text"], select[required]');
        this.inputs.forEach(input => {
            if (!input.value.trim()) {
                isValid = false;
                input.classList.add('is-invalid');

            } else {
                input.classList.remove('is-invalid');
            }

            this.inputFile.forEach((file) => {
                if (file.files.length === 0) {
                    let span = file.parentNode.querySelector('span');

                    if (!span) {
                        span = document.createElement('span');
                        file.parentNode.appendChild(span);
                    }
                    span.textContent = 'No file selected';
                }
            })
        });

        return isValid;
    }

    onChangeFile() {
        this.inputFile.forEach((input) => {
            input.addEventListener('change', (e) => {
                this.file = e.target.files[0];
                this.fileName = this.file ? this.file.name : '';
                const displayId = input.getAttribute('data-target');
                const displayElement = document.getElementById(displayId);

                if (displayElement) {
                    displayElement.textContent = this.file
                        ? `File selected: ${this.fileName}`
                        : 'No file selected';
                }
            })
        })
    }


    ctaAddWarranty() {
        this.submit.addEventListener('click', () => {

            let machineBrandId = this.element.querySelector('#machineBrand')?.value || null;
            let machineModelId = this.element.querySelector('#machineModel').value;
            let dealer = this.element.querySelector('#dealer').value;
            let hoursMachine = this.element.querySelector('#hoursMachine').value;

            let rearTiresModelId = this.element.querySelector('#rearTireModel')?.value || null;
            let rearTiresSizeId = this.element.querySelector('#rearTiresSize')?.value || null;
            let rearPlantCodeLeftTire = this.element.querySelector('#rearPlantCodeLeftTire')?.value || null;
            let rearPlantCodeRightTire = this.element.querySelector('#rearPlantCodeRightTire')?.value || null;
            let productionDateRearLeftTire = this.element.querySelector('#rearProductionDateLeftTire')?.value || null;
            let productionDateRearRightTire = this.element.querySelector('#rearProductionDateRightTire')?.value || null;

            let receiptFile = this.receiptInput?.files[0];
            let speedometerFile = this.speedometerInput?.files[0];

            let formData = new FormData();
            if (receiptFile) {
                formData.append("fileReceipt", receiptFile);
                formData.append("filenameReceipt", receiptFile.name);
            }
            if (speedometerFile) {
                formData.append("fileSpeed", speedometerFile);
                formData.append("filenameSpeedometer", speedometerFile.name);
            }

            formData.append("machineBrand", machineBrandId);
            formData.append("machineModel", machineModelId);
            formData.append("dealer", dealer);
            formData.append("hoursMachine", hoursMachine);

            formData.append("rearTireModel", rearTiresModelId);
            formData.append("rearTiresSize", rearTiresSizeId);
            formData.append("rearPlantCodeLeftTire", rearPlantCodeLeftTire);
            formData.append("rearPlantCodeRightTire", rearPlantCodeRightTire);
            formData.append("rearProductionDateLeftTire", productionDateRearLeftTire);
            formData.append("rearProductionDateRightTire", productionDateRearRightTire);

            this.submitWarranty(formData);
        })
    }


    submitWarranty(data) {
        if (this.checkValidationForm()) {
            this.element.classList.add('loading');
            return youserxp.ajax(this.endpoint, {
                method: 'POST',
                auth: true
            }, data, 'multipart/form-data').then(
                (result) => {
                    this.warranty = result.body;
                    console.log(this.warranty);
                    this.modal.openModal();
                    this.element.classList.remove('loading');
                },
                (err) => {
                    console.error('Error creating warranty:', err);
                    this.element.classList.remove('loading');
                }
            );
        }
    }


    closeListener() {
        this.closeBtn = this.element.querySelector('.generic-modal__cta a');
        this.closeBtn.addEventListener('click', () => {
            this.modal.closeModal();
            this.element.classList.add('loading');
            this.redirectToWarranties();
            this.element.classList.remove('loading');
        })

    }

    redirectToWarranties() {
        let currentUrl = window.location.href;

        if (currentUrl.includes('/extended-warranty')) {
            let newUrl = currentUrl.replace('/extended-warranty', '/my-warranties-listing');
            window.location.href = newUrl;
        }
    }


    init() {
        this.getMachineBrands();
        this.ctaAddWarranty();
        this.onChangeFile();
        this.closeListener();
        // this.getTireSize();
        this.populateRearTiresSizeByModelDropdown()
    }
}

export default ExtendedWarrantyComponent;
